import axios from "./axios";

// interfaces
import { IPaginatedResponse } from "@/types/api/PaginatedResponse";
import { ISingleSearch } from "@/types/api/SingleSearchResponse";
import { IFacets } from "@/types/api/Facets";

// helpers
import API_ROUTES from "./routes.constant";
import { buildUrl } from "./helpers";

export default {
  async getSearch({ params }: { params: Record<string, unknown> }) {
    const resp = await axios.get<IPaginatedResponse<ISingleSearch>>(buildUrl(API_ROUTES.searchUrls.search, params))
      
    return resp.data;
  },

  async getResultsCount(params: Record<string, unknown>) {
    const resp = await axios.get<{ locationsCount: number; spacesCount: number; facets: IFacets; }>(
      buildUrl(API_ROUTES.searchUrls.resultsCount, params)
    )
      
    return resp.data;

  }
};
